import { useEffect } from 'react'
import { playDemoSummary } from './summary-playback'

export const useDemoPlayerSummary = ({
  clock,
  contentRef,
  onComplete,
  summaryVisible,
}: DemoPlayerSummaryParams) => {
  useEffect(() => {
    if (!summaryVisible) {
      return
    }

    let cancelled = false

    const presentSummary = async () => {
      const content = contentRef.current

      if (!content) {
        return
      }

      const reachedBottom = await playDemoSummary({
        content,
        isCancelled: () => cancelled || clock.controller.signal.aborted,
      })

      if (reachedBottom && !cancelled) {
        onComplete()
      }
    }

    presentSummary().catch(error => {
      if (error?.name !== 'AbortError') {
        console.error(error)
      }
    })

    return () => { cancelled = true }
  }, [ clock, contentRef, onComplete, summaryVisible ])

}
